import React, { Component } from 'react'
import './App.css'
import Intro from './components/Intro'
export default class App extends Component {

  render() {
    return (
      <div className='App'>
        <Intro />
      </div>
    )
  }
}